/** Shared helpers extracted from campaigns.service for reuse and testing. */

export const mergeByProperty = (target, source, prop) => {
  source.forEach(sourceElement => {
    let targetElement = target.find(targetElement => {
      return sourceElement[prop] === targetElement[prop];
    })
    targetElement ? Object.assign(targetElement, sourceElement) : target.push(sourceElement);
  })
}

export const makeid = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export const currentTimestamp = () => {
  return Math.round(Date.now() / 1000);
}

export const currentDateStamp = (endOfDay) => {
  const now = new Date();
  const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (endOfDay === true) startOfDay.setUTCHours(23, 59, 59, 0);
  return startOfDay.getTime() / 1000;
}

export const convertDate = (d) => {
  return d.getUTCFullYear() + "-" + ("0"+(d.getUTCMonth()+1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2)
     + " " + ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2) + ":00";
}

export const unpackAderizeMacro = (macro, creative, creatives) => {
  let output = "";
  const actualSettingName = macro.replace(/%%ADERIZE_([^%]+)%%/g,'$1');
  if (macro === '%%ADERIZE_fallbackCreative%%') {
    if (!creative.settings) return output;
    creative.settings.forEach((val) => {
      if (val.key === actualSettingName) {
        output = val.value;
        if (output.value) output = output.value;
      }
    })
    if (output) {
      creatives.forEach((cre) => {
        if(cre.id === output) {
          if (cre.liveCreatives) {
            cre.liveCreatives.forEach((liveCre) => {
              output = liveCre.id;
            })
          }
        }
      })
    }
  }
  return output
}
